import type {
  AuthorizationSubject,
  PortalCapabilityArea,
} from "@whitehaven/permissions";
import type {
  AdminSchedulingCatalogMutationGateway,
  AdminSchedulingCatalogReadGateway,
  AdminSchedulingWorkspaceMutationGateway,
  AdminSchedulingWorkspaceReadGateway,
} from "./scheduling-gateway";
import { resolveAdminSchedulingRoute } from "./scheduling-portal-model";
import { AdminSchedulingCatalogRoute } from "./AdminSchedulingCatalogRoute";
import { AdminSchedulingWorkspaceRoute } from "./AdminSchedulingWorkspaceRoute";

export interface AdminSchedulingRouteProps {
  readonly pathname: string;
  readonly anchorDate: string;
  readonly subject: AuthorizationSubject | null;
  readonly catalogReadGateway: AdminSchedulingCatalogReadGateway | null;
  readonly catalogMutationGateway: AdminSchedulingCatalogMutationGateway | null;
  readonly workspaceReadGateway: AdminSchedulingWorkspaceReadGateway | null;
  readonly workspaceMutationGateway: AdminSchedulingWorkspaceMutationGateway | null;
}

export function AdminSchedulingRoute({
  pathname,
  anchorDate,
  subject,
  catalogReadGateway,
  catalogMutationGateway,
  workspaceReadGateway,
  workspaceMutationGateway,
}: AdminSchedulingRouteProps) {
  const route = resolveAdminSchedulingRoute(pathname);
  if (!route) return null;
  const capabilityArea: PortalCapabilityArea = pathname.startsWith(
    "/admin/resources",
  )
    ? "admin-resources"
    : pathname.startsWith("/admin/calendar")
      ? "admin-calendar"
      : pathname.startsWith("/admin/scheduler")
        ? "admin-scheduler"
        : "admin-appointments";

  return route.kind === "catalog" ? (
    <AdminSchedulingCatalogRoute
      subject={subject}
      capabilityArea={capabilityArea}
      focus={route.focus}
      readGateway={catalogReadGateway}
      mutationGateway={catalogMutationGateway}
    />
  ) : (
    <AdminSchedulingWorkspaceRoute
      subject={subject}
      capabilityArea={capabilityArea}
      view={route.view}
      anchorDate={anchorDate}
      readGateway={workspaceReadGateway}
      mutationGateway={workspaceMutationGateway}
    />
  );
}
